import { calculateBuyersPremium } from '@/utils/calculateBuyersPremium';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getCatalogBuyersPremium } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCurrencyConversion } from '@/redux/modules/currency';
import { getItemModelCatalogId, getItemModelCurrency } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackBuyNowPressedAnalyticsPayload } from '@/utils/amplitude/analytics/bidding/bidding.types';
import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const trackBuyNowRequestSentAnalytics = (payload: TrackBuyNowPressedAnalyticsPayload) => {
    track(TrackingEvents.Bidding.BuyNowRequestSent, payload);
};

export const useTrackBuyNowRequestSentAnalytics = (itemId: number) => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    const catalogId = useAppSelector((state) => getItemModelCatalogId(state, itemId));
    const currency = useAppSelector((state) => getItemModelCurrency(state, itemId));
    const currencyConversion = useAppSelector((state) => getCurrencyConversion(state, currency));
    const buyersPremium = useAppSelector((state) => getCatalogBuyersPremium(state, catalogId));

    return useCallback(
        (makeAnOfferButton: boolean, amount: number) => {
            const conversionToUsd = currencyConversion?.conversionToUsd ?? 0;
            const { amount: buyersPremiumAmount } = calculateBuyersPremium(amount, buyersPremium);
            const lotHammerPriceUsd = amount * conversionToUsd;
            const totalAmount = amount + buyersPremiumAmount;
            const lotTotalPriceUsd = totalAmount * conversionToUsd;

            trackBuyNowRequestSentAnalytics({
                lotHammerPriceUsd,
                lotTotalPriceUsd,
                makeAnOfferButton,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [buyersPremium, currencyConversion?.conversionToUsd, pathname, url]
    );
};
